const MemberNameDenylist = ['iichi', 'ｉｉｃｈｉ', 'support', 'ｓｕｐｐｏｒｔ', 'いいち', 'イイチ', 'サポート'] as const;

export const ABOUT_MAX_LENGTH = 2000;
export const MEMBER_NAME_DENY_PATTERN = new RegExp(MemberNameDenylist.join('|'), 'i');
export const MEMBER_NAME_MAX_LENGTH = 32;

export const Credential = {
  ALCOHOL_SELLER: 'iichi.alcohol_seller',
  BANK_ACCOUNT_REGISTERED: 'iichi.bank_account_registered',
  BUYER: 'iichi.buyer',
  EMAIL_CONFIRMED: 'iichi.email_confirmed',
  FOOD_SELLER: 'iichi.food_seller',
  IICHI_STAFF: 'iichi.iichi_staff',
  PRE_SELLER: 'iichi.pre.seller',
  PROMOTER: 'iichi.promoter',
  SELLER: 'iichi.seller',
  TRADER: 'iichi.trader',
  VINTAGE_SELLER: 'iichi.vintage_seller',
  WMS_INTEGRATED: 'iichi.wms_integrated',
} as const;
export type Credential = (typeof Credential)[keyof typeof Credential];
